import PresenceServices from "../../services/presence/presenceSerives";

function usePresence() {
  const getAllPresence = (params = {}) => {
    return PresenceServices.getAll(params);
  };

  const getOnePresence = (id) => {
    return PresenceServices.getOne(id);
  };

  const createPresence = (data) => {
    return PresenceServices.create(data);
  };

  const updatePresence = (id, data) => {
    return PresenceServices.update(id, data);
  };

  const deletePresence = (id) => {
    return PresenceServices.delete(id);
  };

  const insertOrUpdatePresence = (data) => {
    return PresenceServices.insertOrUpdate(data);
  }

  return {
    getAllPresence,
    getOnePresence,
    createPresence,
    updatePresence,
    deletePresence,
    getOnePresence,
    insertOrUpdatePresence,
  };
}

export default usePresence;
